<template>
  <div class="order-carts-container">
    <div class="margin-top">
      <el-table :data="aOrderDetailCartsInfo.carts" border style="width: 100%" v-loading="loading">
        <el-table-column prop="prodName" :label="$t('aOrderDetailCarts.productName')" align="center" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.prodName }}({{ scope.row.specValue }})
          </template>
        </el-table-column>
        <el-table-column prop="productId" :label="$t('aOrderDetailCarts.productId')" align="center" min-width="120">
        </el-table-column>
        <el-table-column prop="cartNum" :label="$t('aOrderDetailCarts.quantity')" align="center" width="100">
        </el-table-column>
        <el-table-column prop="payPrice" :label="$t('aOrderDetailCarts.paymentAmount')" align="center" width="120">
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('aOrderDetailCarts.status')" align="center" width="120">
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('aOrderDetailCarts.paymentTime')" align="center" width="180">
        </el-table-column>
      </el-table>

      <el-row class="margin-top">
        <el-col :span="24" class="text-right">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getOrderCarts } from '@/api/order/aOrderDetailApi'

export default {
  name: 'AOrderDetailCarts',
  data() {
    return {
      aOrderDetailCartsInfo: {
        carts: [],
        orderId: '',
        prodNameLike: '',
        personNameLike: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.aOrderDetailCartsInfo.orderId = params.orderId
      this.loadOrderCartsData()
    },
    loadOrderCartsData() {
      this.loading = true
      const params = {
        orderId: this.aOrderDetailCartsInfo.orderId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      getOrderCarts(params).then(response => {
        this.aOrderDetailCartsInfo.carts = response.data
        this.pagination.total = response.records
        this.loading = false
      }).catch(error => {
        console.error('获取订单商品失败:', error)
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadOrderCartsData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadOrderCartsData()
    }
  }
}
</script>

<style scoped>
.order-carts-container {
  padding: 15px;
}

.margin-top {
  margin-top: 15px;
}

.text-right {
  text-align: right;
}
</style>